import { render, staticRenderFns } from "./organization-type.vue?vue&type=template&id=11d2a31e&"
import script from "./organization-type.vue?vue&type=script&lang=js&"
export * from "./organization-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports